import { useLocation, Outlet } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { PageTransition } from "@/lib/motion";
import { NAV_HEIGHT } from "@/lib/navbar";

/**
 * PageLayout — global layout for all public pages.
 * Renders the shared Navbar + cinematic page transitions via AnimatePresence.
 * Dashboard pages have their own layouts and are excluded.
 *
 * La Navbar est en `position: fixed` (pour rester intégrée au hero sans
 * jamais bouger) donc elle ne réserve plus d'espace dans le flux — on
 * compense avec ce padding-top. Les pages avec un hero plein cadre
 * (Home, BecomeVendor, IAPage, FAQ) l'annulent avec un `margin-top`
 * négatif sur leur première section pour passer sous la navbar.
 */
export default function PageLayout() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <AnimatePresence mode="wait" initial={false}>
        <PageTransition key={location.pathname} style={{ paddingTop: NAV_HEIGHT }}>
          <Outlet />
        </PageTransition>
      </AnimatePresence>
      <SiteFooter />
    </>
  );
}
